import { Tooltip } from './Tooltip'
import { useStyles } from './button.style'

export const Button = function ({ children, _ref, className = '', variant = 'primary', size = '', iconClass = '', tooltipLabel = '', ...props }) {
  const classes = useStyles()

  if ((variant === 'icon') || (variant === 'icon-link') || (variant === 'icon-secondary')) {
    let variantClass

    switch (variant) {
      case 'icon-secondary':
        variantClass = classes.iconSecondary
        break
      case 'icon-link':
        variantClass = classes.link
        break
      default:
        variantClass = classes.button
    }

    return (
      <Tooltip
        title={tooltipLabel}
        placement="top"
      >
        <button
          type="button"
          className={`${variantClass} ${className}`}
          {...props}
        >
          {children}
        </button>
      </Tooltip>
    )
  } else {
    let variantClass
    let sizeClass = ''

    switch (variant) {
      case 'link':
        variantClass = classes.link
        break
      case 'inline-link':
        variantClass = classes.inlineLink
        break
      case 'secondary':
        variantClass = classes.secondary
        break
      case 'mini':
        variantClass = classes.mini
        break
      case 'mini-secondary':
        variantClass = classes.miniSecondary
        break
      default:
        variantClass = classes.button
    }

    switch (size) {
      case 'large':
        sizeClass = classes.large
        break
    }

    return (
      <button className={`${variantClass} ${sizeClass} ${className}`} ref={_ref} {...props}>
        {children}
      </button>
    )
  }
}
